// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { apiBaseUrl, supabasePublishableKey } from '@/utils/config';
import { Preferences } from '@capacitor/preferences';
import { Capacitor } from '@capacitor/core';

const SUPABASE_URL = apiBaseUrl;
const SUPABASE_PUBLISHABLE_KEY = supabasePublishableKey;

// ✅ Storage adapter pour Capacitor utilisant le keychain natif
const capacitorStorage = {
  getItem: async (key: string) => {
    const { value } = await Preferences.get({ key });
    return value;
  },
  setItem: async (key: string, value: string) => {
    await Preferences.set({ key, value });
  },
  removeItem: async (key: string) => {
    await Preferences.remove({ key });
  },
};

// ✅ Utiliser le storage adapter uniquement sur mobile natif
const storage = Capacitor.isNativePlatform() ? capacitorStorage : undefined;

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: storage,
    autoRefreshToken: true, // ✅ Rafraîchir automatiquement les tokens
    persistSession: true,   // ✅ Persister la session
    detectSessionInUrl: true, // ✅ Pour les magic links
  },
});
